import SwaggerUIBundle from 'swagger-ui-dist/swagger-ui-bundle.js'
import 'swagger-ui-dist/swagger-ui.css';

const spec = require('./swagger-config.yaml');

const ui = SwaggerUIBundle({
  spec,
  dom_id: '#swagger',
});
